import { inject, Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';
import { Action, createAction, Store } from '@ngrx/store';
import { of } from 'rxjs';
import {
  catchError,
  distinctUntilChanged,
  exhaustMap,
  filter,
  map,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { SubscriptionAdapter } from '../../adapters/subscription.adapter';
import { AppState } from '../../app.reducer';
import { selectLoggedIn } from '../auth/auth.reducer';
import { loadSubscription, loadSubscriptionFailure, loadSubscriptionSuccess } from './subscription.actions';
import { selectSubscriptionLoaded } from './subscription.reducer';

export const SubscriptionEffectInit = createAction('[Subscription/Effects] Subscription Effect Initialized');

@UntilDestroy()
@Injectable()
export class SubscriptionEffects implements OnInitEffects {
  private readonly actions$ = inject(Actions);
  private readonly subscriptionAdapter = inject(SubscriptionAdapter);
  private readonly store = inject(Store<AppState>);
  
  ngrxOnInitEffects(): Action {
    this.store
      .select(selectLoggedIn)
      .pipe(untilDestroyed(this), distinctUntilChanged())
      .subscribe((loggedIn) => {
        if (loggedIn) {
          this.store.dispatch(loadSubscription());
        }
      });
    return SubscriptionEffectInit();
  }

  loadSubscription$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadSubscription),
      withLatestFrom(this.store.select(selectSubscriptionLoaded)),
      filter(([action, loaded]) => action.force === true || !loaded),
      exhaustMap(() =>
        this.subscriptionAdapter.getSubscription().pipe(
          map((subscription) => loadSubscriptionSuccess({ subscription })),
          catchError((error) => {
            return of(loadSubscriptionFailure({ error }));
          })
        )
      )
    )
  );

  loadSubscriptionFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadSubscriptionFailure),
        tap((action) => {
          //Todo: Add proper error handling. Maybe with a toasty?
          //alert(action.error.message);
        })
      ),
    { dispatch: false }
  );
}
